import { ReasonPrediction } from '@modules/feedback/store/types';

export const toReasonManipulations = (
  reasonPredictions?: ReasonPrediction[],
) => {
  if (!reasonPredictions?.length) {
    return [];
  }

  return reasonPredictions.map((reasonPrediction) => ({
    manipulationType: reasonPrediction.manipulationType,
    reason: {
      labelID: reasonPrediction.prediction.id,
      isSuggested: reasonPrediction.isSuggested,
      relatedRCs: reasonPrediction.relatedRCs,
    },
  }));
};
